import create from 'zustand'
import { State } from './interface'

export const useHeader = create<State>((set) => ({
  isVisible: true,
  hideHeader: () => set(() => ({ isVisible: false })),
  showHeader: () => set(() => ({ isVisible: true })),
}))
